import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

interface SidebarFlyoutValue {
  openFlyoutId: string | null;
  closeFlyout: (_id: string) => void;
  openFlyout: (_id: string) => void;
  toggleFlyout: (_id: string) => void;
}

const SidebarFlyoutContext = createContext<SidebarFlyoutValue>({
  openFlyoutId: null,
  closeFlyout: () => {},
  openFlyout: () => {},
  toggleFlyout: () => {},
});

export const useSidebarFlyout = () => useContext(SidebarFlyoutContext);

const SidebarFlyoutProvider = ({ children }: { children: React.ReactNode }) => {
  const [openFlyoutId, setOpenFlyoutId] = useState<string | null>(null);

  const openFlyout = useCallback((id: string) => setOpenFlyoutId(id), []);

  const closeFlyout = useCallback(
    (id: string) => setOpenFlyoutId((current) => (current === id ? null : current)),
    [],
  );

  const toggleFlyout = useCallback(
    (id: string) => setOpenFlyoutId((current) => (current === id ? null : id)),
    [],
  );

  const value = useMemo(
    () => ({ closeFlyout, openFlyout, openFlyoutId, toggleFlyout }),
    [closeFlyout, openFlyout, openFlyoutId, toggleFlyout],
  );

  return <SidebarFlyoutContext.Provider value={value}>{children}</SidebarFlyoutContext.Provider>;
};

export default SidebarFlyoutProvider;
